import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { forwardRef } from '@angular/core';

/**
 * Returns a provider for a custom form component that implements the ControlValueAccessor interface.
 * @param component the component that implements the ControlValueAccessor interface
 */
export const getCustomFormComponentControlValueAccessorProvider = (component: unknown) => {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => component),
    multi: true,
  };
};
